import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { PrintReportParams, PrintReportServerData } from './printReport.types'

export class PrintReportProvider {
  private get url(): string {
    return `${this.baseUrl}/printreport_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public get(params: PrintReportParams, body: {} = {}): Promise<HttpServiceResponse<PrintReportServerData>> {
    const query = qs.stringify(params)

    return this.http.post(`${this.url}?${query}`, body)
  }
}
